export default "__VITE_ASSET__DWeP0WfK__"